import { HttpBackend } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class ActiveWorkersWoMandatoryPPEDirectCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class ActiveWorkersWoMedicalExaminationDirectCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class OccupationalRiskPreventionDirectKpiCfg {
  public activeWorkersWoMandatoryPPEDirect: ActiveWorkersWoMandatoryPPEDirectCfg;
  public pendingActiveWorkersWoMedicalExaminationDirect: ActiveWorkersWoMedicalExaminationDirectCfg;
  public expiredActiveWorkersWoMedicalExaminationDirect: ActiveWorkersWoMedicalExaminationDirectCfg;
  public processingActiveWorkersWoMedicalExaminationDirect: ActiveWorkersWoMedicalExaminationDirectCfg;
  public fitActiveWorkersWoMedicalExaminationDirect: ActiveWorkersWoMedicalExaminationDirectCfg;
}

@Injectable()
export class OccupationalRiskPreventionDirectKpiCfgService extends CfgService<OccupationalRiskPreventionDirectKpiCfg> {
  json: any = {
    activeWorkersWoMandatoryPPEDirect: {
      summaryEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMandatoryPPE?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMandatoryPPE/detail?beginDate={1}&endDate={2}"
    },
    pendingActiveWorkersWoMedicalExaminationDirect: {
      summaryEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMedicalExamination?searchType=1&beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMedicalExamination/detail?searchType=1&beginDate={1}&endDate={2}"
    },
    expiredActiveWorkersWoMedicalExaminationDirect: {
      summaryEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMedicalExamination?searchType=2&beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMedicalExamination/detail?searchType=2&beginDate={1}&endDate={2}"
    },
    processingActiveWorkersWoMedicalExaminationDirect: {
      summaryEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMedicalExamination?searchType=3&beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMedicalExamination/detail?searchType=3&beginDate={1}&endDate={2}"
    },
    fitActiveWorkersWoMedicalExaminationDirect: {
      summaryEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMedicalExamination?searchType=4&beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardDirectApiUrl}/risks/activeWorkers/{0}/withoutMedicalExamination/detail?searchType=4&beginDate={1}&endDate={2}"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/occupationalRiskPreventionDirectKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
